/* global isTouchDevice:false */
/* global OFFCANVAS_NAVIGATION_BREAKPOINT:false */

(function() {

	if (isTouchDevice) {
		var dropdownMenuItems = document.querySelectorAll('.js-toggle-menu-dropdown-link');

		Array.prototype.forEach.call(dropdownMenuItems, function(item) {
			item.addEventListener('click', function(e) {
				e.preventDefault();
				e.stopPropagation();

				return false;
			});
		});
	}

	var MainNavigation = function(element) {
		this.active = false; // state of offcanvas navigation
		this.element = element;
		this.revealHeaderDistance = 200;
		var navigation = this;

		navigation.eventHandler = handleEvent.bind(navigation);

		if (window.innerWidth >= OFFCANVAS_NAVIGATION_BREAKPOINT && !navigation.active) {
			navigation = initStickyNavigation(navigation);
		}

		window.addEventListener('resize', function() {
			if (window.innerWidth >= OFFCANVAS_NAVIGATION_BREAKPOINT && !navigation.active) {
				navigation = initStickyNavigation(navigation);
			}

			if (window.innerWidth < OFFCANVAS_NAVIGATION_BREAKPOINT) {
				navigation = destroyStickyNavigation(navigation);
			}
		});
	};

	function initStickyNavigation(navigation) {
		navigation.active = true;

		const customRevealBoundary = document.getElementById('js-reveal-header-boundary');
		if (customRevealBoundary) {
			var offset = customRevealBoundary.getAttribute('data-reveal-offset') || 0;
			navigation.revealHeaderDistance = customRevealBoundary.offsetTop + parseInt(offset)
		}

		window.addEventListener('scroll', navigation.eventHandler);

		return navigation;
	};

	function destroyStickyNavigation(navigation) {
		navigation.active = false;

		window.removeEventListener('scroll', navigation.eventHandler);

		return navigation;
	};

	function handleEvent(event) {
		switch(event.type) {
			case 'scroll':
				initScroll(this, event);
				break;
		}
	};

	function showNavigation(navigation) {
		navigation.element.classList.add('header__wrapper--is-visible');
		navigation.element.setAttribute('data-visible', 'true');
	};

	function hideNavigation(navigation) {
		navigation.element.classList.remove('header__wrapper--is-visible');
		navigation.element.setAttribute('data-visible', 'false');
	};

	function initScroll(navigation) {
		if (window.pageYOffset > navigation.revealHeaderDistance) {
			showNavigation(navigation);
		} else {
			hideNavigation(navigation);
		}
	};

	const stickyHeader = document.getElementById('js-sticky-header');
	if (stickyHeader) {
		new MainNavigation(stickyHeader);
	}
}());
